import { BaseIcon, BaseIconProps } from '../BaseIcon';

export type LockIconProps = Omit<BaseIconProps, 'children'>;

export const LockIcon = ({ ...props }: LockIconProps) => (
  <BaseIcon width="15" height="18.6" viewBox="0 0 10 10" {...props}>
    <g strokeWidth={0} strokeLinecap="square">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.14286 2.75C2.14286 1.23122 3.42204 0 5 0C5.00616 0 5.01232 1.87869e-05 5.01848 5.63044e-05C6.58793 0.00962327 7.85714 1.23715 7.85714 2.75V3.4375H9.28572C9.6802 3.4375 10 3.7453 10 4.125V10.3125C10 10.6922 9.6802 11 9.28571 11H0.714285C0.319796 11 0 10.6922 0 10.3125V4.125C0 4.07754 0.00499682 4.0312 0.0145117 3.98645C0.0811162 3.67316 0.369108 3.4375 0.714286 3.4375H2.14286V2.75ZM6.42857 2.75V3.4375H3.57143V2.75C3.57143 1.99061 4.21102 1.375 5 1.375C5.78898 1.375 6.42857 1.99061 6.42857 2.75ZM1.42857 9.625V4.8125H8.57143V9.625H1.42857Z"
      />
    </g>
  </BaseIcon>
);

LockIcon.displayName = 'LockIcon';
